module.exports = __webpack_public_path__ + "img/nature-73.13fa52e4.jpg";